import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=6478c570&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"
import style0 from "./user-list.vue?vue&type=style&index=0&id=6478c570&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6478c570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6478c570')) {
      api.createRecord('6478c570', component.options)
    } else {
      api.reload('6478c570', component.options)
    }
    module.hot.accept("./user-list.vue?vue&type=template&id=6478c570&scoped=true", function () {
      api.rerender('6478c570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/users/list/user-list.vue"
export default component.exports